﻿import { Component } from '@angular/core';
import { Tabla } from '../../tabla';

@Component({
    template: `
    <app-tabla [tabla]="tabla"></app-tabla>
` })
export class AlumnoUserComponent {

    tabla: Tabla = {
        titulo: 'Alumnos',
        endPoint: '/rest-api/user/alumno',
        editable: true,
        nuevo: true,
        columnas: [
            {
                name: 'ID',
                prop: 'id',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Nombre',
                prop: 'nombre',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 300
            },
            {
                name: 'Casa',
                prop: 'casa',
                cell: 'nombre',
                editable: true,
                resizeable: true,
                casa: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Curso',
                prop: 'grado',
                cell: 'nombre',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Categoria',
                prop: 'grado.categoria',
                cell: 'nombre',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Sexo',
                prop: 'sexo',
                cell: 'nombre',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 100
            }
        ]
    };

}
